module.exports = __webpack_public_path__ + "img/profile_bg.3964515c.png";